export default {
  tabs: {
    api: "API",
    assistant: "Assistente",
    agentic: "Agentic",
    gateway: "Gateway",
    engine: "Engine"
  },
  modes: {
    logs: "Logs",
    chats: "Chats",
    tools: "Ferramentas",
    agents: "Agentes",
    history: "Histórico"
  },
  agents: {
    searchPlaceholder: "Buscar nas execuções de agentes...",
    terminalTitle: "Execuções de agentes (Engine)",
    liveFeed: "Feed em tempo real",
    itemCount: "{{count}} execuções",
    empty: "Nenhuma execução no período selecionado.",
    loadError: "Não foi possível carregar o feed de execuções de agentes.",
    refresh: "Atualizar",
    sessions: "Agentes",
    allSessions: "Todos os agentes",
    noSessions: "Nenhuma execução no período.",
    executions: "execuções",
    openSession: "Abrir agente",
    duration: "Duração",
    steps: "Etapas",
    tokens: "Tokens"
  },
  chats: {
    searchPlaceholder: "Buscar nas conversas...",
    terminalTitle: "Conversas anonimizadas (Agentic)",
    liveFeed: "Feed em tempo real",
    itemCount: "{{count}} conversas",
    empty: "Nenhuma conversa no período selecionado.",
    noResponse: "Sem resposta registrada",
    loadError: "Não foi possível carregar o feed de conversas.",
    refresh: "Atualizar",
    sessions: "Sessões",
    allSessions: "Todas as sessões",
    noSessions: "Nenhuma sessão no período.",
    messages: "msgs",
    filterSession: "Filtrar por esta sessão",
    expand: "Expandir",
    collapse: "Contrair",
    openSession: "Abrir conversa"
  },
  tools: {
    searchPlaceholder: "Buscar nas chamadas de ferramentas...",
    terminalTitle: "Chamadas de ferramentas MCP (Gateway)",
    liveFeed: "Feed em tempo real",
    itemCount: "{{count}} chamadas",
    empty: "Nenhuma chamada de ferramenta no período selecionado.",
    params: "Parâmetros",
    loadError: "Não foi possível carregar o feed de chamadas de ferramentas.",
    refresh: "Atualizar",
    sessions: "Sessões",
    allSessions: "Todas as sessões",
    noSessions: "Nenhuma sessão no período.",
    calls: "chamadas",
    failed: "falhas",
    lastTool: "Última ferramenta",
    filterSession: "Filtrar por esta sessão",
    toggleResult: "Ver retorno",
    resultPreview: "Retorno (trecho)",
    openSession: "Abrir sessão"
  },
  agenticTerminalTitle: "Terminal de Logs do Agentic",
  gatewayTerminalTitle: "Terminal de Logs do Gateway",
  engineTerminalTitle: "Terminal de Logs do Engine",
  searchPlaceholder: "Buscar nos logs...",
  level: "Nível",
  allLevels: "Todos os níveis",
  connectionError: "Erro de conexão",
  waitingForLogs: "Aguardando logs...",
  paused: "Pausado",
  liveUpdatesFailing: "Tempo real com falhas — dados podem estar desatualizados",
  pause: "Pausar",
  resume: "Retomar",
  title: "Logs",
  description: "Visualize logs do sistema em tempo real",
  selectFile: "Selecionar arquivo de log",
  selectFileToView: "Selecione um arquivo de log para visualizar",
  noFilesFound: "Nenhum arquivo de log encontrado",
  noLogEntries: "Nenhuma entrada de log para exibir",
  refreshFileList: "Atualizar lista de arquivos",
  startStreaming: "Iniciar monitoramento em tempo real",
  stopStreaming: "Parar monitoramento em tempo real",
  start: "Iniciar",
  stop: "Parar",
  clearLogs: "Limpar logs",
  lineCount: "{{count}} linhas",
  streamingActive: "Monitoramento em tempo real ativo",
  streamingStopped: "Monitoramento em tempo real inativo",
  liveStreaming: "Recebendo logs em tempo real",
  monitoringStopped: "Monitoramento de logs parado",
  terminalTitle: "Terminal de Log do Sistema",
  fullscreenTitle: "Terminal em Tela Cheia",
  copied: "Logs copiados",
  copiedDescription: "Os logs foram copiados para a área de transferência",
  copyError: "Erro ao copiar",
  copyErrorDescription: "Não foi possível copiar os logs para a área de transferência",
  copyLogsTitle: "Copiar Logs",
  reconnecting: "Reconectando...",
  dateSelector: "Data",
  liveOption: "Tempo real (hoje)",
  historicalSnapshot: "Snapshot histórico — sem atualização em tempo real",
  loadingHistorical: "Carregando logs históricos...",
  historicalUnavailable: "Arquivo histórico não disponível — pode ter sido rotacionado.",
  failedToListFiles: "Não foi possível carregar a lista de datas disponíveis."
} as const;
